import { IntegrationProviderId } from 'src/api/generated';

const DEFAULT_MIN_SYNC_FREQUENCY_MINUTES = 30;
const TWO_CLICS_MIN_SYNC_FREQUENCY_MINUTES = 180;
const WASI_MIN_SYNC_FREQUENCY_MINUTES = 180;
const TOPPROPIEDADES_MIN_SYNC_FREQUENCY_MINUTES = 180;
const KITEPROP_MIN_SYNC_FREQUENCY_MINUTES = 180;

const PROVIDER_MIN_SYNC_FREQUENCY_MINUTES: Record<string, number> = {
  '2clics': TWO_CLICS_MIN_SYNC_FREQUENCY_MINUTES,
  [IntegrationProviderId.WASI]: WASI_MIN_SYNC_FREQUENCY_MINUTES,
  toppropiedades: TOPPROPIEDADES_MIN_SYNC_FREQUENCY_MINUTES,
  kiteprop: KITEPROP_MIN_SYNC_FREQUENCY_MINUTES,
};

/**
 * Resolves the minimum allowed sync frequency for an integration provider.
 */
export const getIntegrationMinSyncFrequencyMinutes = (
  providerId: IntegrationProviderId
): number => {
  return (
    PROVIDER_MIN_SYNC_FREQUENCY_MINUTES[String(providerId)] ??
    DEFAULT_MIN_SYNC_FREQUENCY_MINUTES
  );
};
